import { createFileRoute, useRouter } from '@tanstack/react-router';
import EntitySetupWizard from 'containers/EntitySetupWizard';

function EntitySetupRoute() {
  const router = useRouter();
  const goToDashboard = () => router.history.push('/dashboard');
  return (
    <EntitySetupWizard onComplete={goToDashboard} onCancel={goToDashboard} />
  );
}

export const Route = createFileRoute('/_authenticated/entitySetup')({
  component: EntitySetupRoute,
});
